var _filter, _filter2, _rect, _ellipse, _text, _text2, _g, _g2, _g3, _g4, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataTransformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 850 380",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgDark",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a0a0f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#111118"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f0f15"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rawCard",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1c1c27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#12121a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insightCard",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c2d1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#071a12"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "transformGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f43f5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#a855f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#10b981"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 10,
    floodColor: "#000",
    floodOpacity: 0.4
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 850,
    height: 380,
    fill: "url(#bgDark)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 425,
    cy: 190,
    rx: 300,
    ry: 150,
    fill: "#7c3aed",
    opacity: 0.03
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 40,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "system-ui",
    fontSize: 24,
    fontWeight: "bold"
  }, "The Transformation")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 62,
    textAnchor: "middle",
    fill: "#6b7280",
    fontFamily: "system-ui",
    fontSize: 13
  }, "From structured data to actionable insights")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 90)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 240,
    rx: 12,
    fill: "url(#rawCard)",
    stroke: "#374151",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 40,
    rx: 12,
    fill: "#1f1f2a"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 300,
    height: 12,
    fill: "#1f1f2a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 5,
    fill: "#f43f5e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 20,
    r: 5,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 20,
    r: 5,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 25,
    textAnchor: "middle",
    fill: "#9ca3af",
    fontFamily: "monospace",
    fontSize: 11
  }, "raw_analytics.json"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 60)",
    fontFamily: "monospace",
    fontSize: 10
  }, /*#__PURE__*/React.createElement("text", {
    y: 0,
    fill: "#f43f5e"
  }, "{\""), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 0,
    fill: "#60a5fa"
  }, "analytics_data"), /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 0,
    fill: "#f43f5e"
  }, "\":"), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 0,
    fill: "#fbbf24"
  }, "{"), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 18,
    fill: "#60a5fa"
  }, "\"total_users\""), /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 18,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 18,
    fill: "#22c55e"
  }, "15847"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 18,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 36,
    fill: "#60a5fa"
  }, "\"active_sessions\""), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 36,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 36,
    fill: "#22c55e"
  }, "3291"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 36,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 54,
    fill: "#60a5fa"
  }, "\"avg_duration\""), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 54,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 107,
    y: 54,
    fill: "#22c55e"
  }, "847.3"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 54,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 72,
    fill: "#60a5fa"
  }, "\"bounce_rate\""), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 72,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 72,
    fill: "#22c55e"
  }, "0.234"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 72,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 90,
    fill: "#60a5fa"
  }, "\"conversions\""), /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 90,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 90,
    fill: "#22c55e"
  }, "412"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 90,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 108,
    fill: "#60a5fa"
  }, "\"revenue\""), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 108,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 108,
    fill: "#22c55e"
  }, "28493.50"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 108,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 126,
    fill: "#60a5fa"
  }, "\"top_sources\""), /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 126,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 126,
    fill: "#fbbf24"
  }, "[...]"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 126,
    fill: "#9ca3af"
  }, ","), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 144,
    fill: "#60a5fa"
  }, "\"events\""), /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 144,
    fill: "#9ca3af"
  }, ":"), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 144,
    fill: "#fbbf24"
  }, "[...]"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 162,
    fill: "#fbbf24"
  }, "}"), /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 162,
    fill: "#f43f5e"
  }, "}")), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 225,
    textAnchor: "middle",
    fill: "#6b7280",
    fontFamily: "system-ui",
    fontSize: 11
  }, "Structured (Machine) Format"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(370, 180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -20,
    width: 110,
    height: 40,
    rx: 20,
    fill: "none",
    stroke: "url(#transformGrad)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55, 0)",
    filter: "url(#glow2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#1a1a2e",
    stroke: "#a855f7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-8 L2,-2 L8,0 L2,2 L0,8 L-2,2 L-8,0 L-2,-2 Z",
    fill: "#c084fc"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 0,
    r: 3,
    fill: "#f43f5e",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "15;95;15",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f43f5e;#a855f7;#10b981;#a855f7;#f43f5e",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 0,
    r: 2,
    fill: "#a855f7",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "35;95;15;35",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 40,
    textAnchor: "middle",
    fill: "#a855f7",
    fontFamily: "system-ui",
    fontSize: 10,
    fontWeight: 500
  }, "LLM + Generative UI"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500, 90)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 240,
    rx: 12,
    fill: "url(#insightCard)",
    stroke: "#10b981",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 40,
    rx: 12,
    fill: "#0d3325"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 300,
    height: 12,
    fill: "#0d3325"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#10b981",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4,-2 L0,-6 L4,-2 L4,4 L-4,4 Z",
    fill: "#34d399"
  })), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 25,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui",
    fontSize: 12,
    fontWeight: 600
  }, "Analytics Report"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 60)",
    fontFamily: "system-ui"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 0,
    fill: "#34d399",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83D\uDCC8 User Growth"), /*#__PURE__*/React.createElement("text", {
    y: 18,
    fill: "#a7f3d0",
    fontSize: 10
  }, "15,847 total users with 3,291 active"), /*#__PURE__*/React.createElement("text", {
    y: 32,
    fill: "#6ee7b7",
    fontSize: 9,
    opacity: 0.8
  }, "sessions (+12% from last week)")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 55)"
  }, /*#__PURE__*/React.createElement("text", {
    y: 0,
    fill: "#34d399",
    fontSize: 11,
    fontWeight: 600
  }, "\u23F1\uFE0F Engagement"), /*#__PURE__*/React.createElement("text", {
    y: 18,
    fill: "#a7f3d0",
    fontSize: 10
  }, "Average session: 14 min 7 sec"), /*#__PURE__*/React.createElement("text", {
    y: 32,
    fill: "#6ee7b7",
    fontSize: 9,
    opacity: 0.8
  }, "Bounce rate improved to 23.4%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 110)"
  }, /*#__PURE__*/React.createElement("text", {
    y: 0,
    fill: "#34d399",
    fontSize: 11,
    fontWeight: 600
  }, "\uD83D\uDCB0 Revenue"), /*#__PURE__*/React.createElement("text", {
    y: 18,
    fill: "#a7f3d0",
    fontSize: 10
  }, "$28,493.50 from 412 conversions"), /*#__PURE__*/React.createElement("text", {
    y: 32,
    fill: "#6ee7b7",
    fontSize: 9,
    opacity: 0.8
  }, "Avg. order value: $69.16"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220, 175)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 8,
    height: 15,
    rx: 2,
    fill: "#10b981",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 8,
    height: 25,
    rx: 2,
    fill: "#10b981",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0,
    width: 8,
    height: 35,
    rx: 2,
    fill: "#10b981",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 5,
    width: 8,
    height: 30,
    rx: 2,
    fill: "#34d399",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: -5,
    width: 8,
    height: 40,
    rx: 2,
    fill: "#6ee7b7"
  })), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 225,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui",
    fontSize: 11
  }, "Human-Readable Format"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui",
    fontSize: 13,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 350,
    textAnchor: "middle",
    fill: "#f43f5e"
  }, "BEFORE"), /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 350,
    textAnchor: "middle",
    fill: "#10b981"
  }, "AFTER"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 3,
    fill: "#a855f7",
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 60,
    r: 4,
    fill: "#10b981",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 830,
    cy: 350,
    r: 2,
    fill: "#f43f5e",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 320,
    r: 3,
    fill: "#3b82f6",
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTransformation);
export default __webpack_public_path__ + "static/media/data-transformation.1dd239c487696c895cf37b0908ea3c7d.svg";
export { ForwardRef as ReactComponent };